import dayjs from 'dayjs';
import { type AggregatedMetrics } from '@prerender/prerender-shared/FE';

import { restApi } from '~features/api/restApiSlice';
import type { DateWindow } from './EmptyScope';

export const CRAWLER_REQUESTS_VOLUME_ENDPOINT = '/v4/aggregated-metrics/pages-crawled-volume';

function crawlerRequestsTotalParams({ dateFrom, dateTo }: DateWindow) {
  return {
    dateFrom: dayjs(dateFrom).startOf('day').toISOString(),
    dateTo: dayjs(dateTo).endOf('day').toISOString(),
    firstDayOfWeek: dayjs().localeData().firstDayOfWeek(),
    timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
  };
}

export const crawlerRequestsTotalApi = restApi.injectEndpoints({
  endpoints: (builder) => ({
    getCrawlerRequestsTotal: builder.query<number, DateWindow>({
      query: (window) => ({ url: CRAWLER_REQUESTS_VOLUME_ENDPOINT, params: crawlerRequestsTotalParams(window) }),
      transformResponse: ({ total_cache_hit, total_cache_miss }: AggregatedMetrics.PagesCrawledVolumeResult) =>
        total_cache_hit + total_cache_miss,
    }),
  }),
});

export const { useGetCrawlerRequestsTotalQuery } = crawlerRequestsTotalApi;
